if (!customElements.get('erya-card-gallery')) {
  customElements.define('erya-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.images = [...this.querySelectorAll('.erya-card-gallery__image')];
      this.indicators = [...this.querySelectorAll('[data-gallery-indicator]')];
      this.link = this.closest('a');
      this.wanted = 0;
      this.active = 0;
      this.paint(0);
      if (this.images.length < 2 || !this.link) return;
      const {signal} = this.abort;
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        this.images.forEach(image => {image.loading = 'eager';});
      }, {signal});
      this.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        this.position = event.clientX;
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const bounds = this.getBoundingClientRect();
          if (!bounds.width) return;
          let progress = Math.max(0, Math.min(.9999, (this.position - bounds.left) / bounds.width));
          if (getComputedStyle(this).direction === 'rtl') progress = 1 - progress;
          this.select(Math.min(this.images.length - 1, Math.floor(progress * this.images.length)));
        });
      }, {signal, passive:true});
      this.addEventListener('pointerleave', () => {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.select(0);
      }, {signal});
      this.link.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        event.stopPropagation();
        const rtl = getComputedStyle(this).direction === 'rtl';
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.images.length - 1
          : (this.wanted + (event.key === 'ArrowRight' ? (rtl ? -1 : 1) : (rtl ? 1 : -1)) + this.images.length) % this.images.length;
        this.select(next);
      }, {signal});
    }
    select(index) {
      this.wanted = index;
      const image = this.images[index];
      if (!image || index === this.active) return;
      image.loading = 'eager';
      if (image.complete && image.naturalWidth > 0) this.paint(index);
      else image.decode().then(() => {
        if (this.isConnected && this.wanted === index) this.paint(index);
      }).catch(() => {});
    }
    paint(index) {
      this.active = index;
      this.dataset.activeIndex = String(index);
      this.images.forEach((image, position) => {
        image.dataset.active = String(position === index);
        image.setAttribute('aria-hidden', String(position !== index));
      });
      this.indicators.forEach((indicator, position) => indicator.dataset.active = String(position === index));
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}
